<template>
  <v-layout column align-center v-scroll="searchMore">
    <v-col
      cols="7"
      md="7"
      lg="7"
      xl="7"
      sm="12"
      xs="2"
      xm="2"
      class="mt-8 ml-0"
    >
      <div id="main">
        <v-row :class="{ 'ml-n12': $vuetify.breakpoint.mdAndUp }">
          <span
            class="mb-7 text-right display-1 font-weight-bold grey--text text--darken-1"
          >
            {{ "Modems" }}</span
          >
        </v-row>

        <v-row id="filtro" class="pl-2 ml-0 grey lighten-5">
          <v-col cols="4" class="pl-4">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="searchText"
                dense
                label="Regular"
                :placeholder="$vuetify.lang.t('$vuetify.NOME')"
                single-line
                solo
                max-width="200"
                append-icon="mdi-magnify"
                @click:append="search()"
                @keypress.enter.stop.prevent="search()"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col class="mt-7 ml-3">
            <TooltipButton
              v-if="$hasPermission('MODEMS-NOVO', [])"
              :label="$vuetify.lang.t('$vuetify.NOVO_MODEM')"
              :message="$vuetify.lang.t('$vuetify.NOVO_MODEM')"
              :event="createModem"
              :mobile="$vuetify.breakpoint.xs"
              :isText="false"
            ></TooltipButton>
          </v-col>
        </v-row>

        <v-row class="pl-2 pr-2" style="margin-left: -2px">
          <v-expansion-panels class="ma-1">
            <v-expansion-panel
              v-for="(modem, i) in modems"
              :key="i"
              hide-actions
              :disabled="disabled"
            >
              <v-expansion-panel-header style="z-index: 1000">
                <v-row align="center" no-gutters>
                  <v-col v-show="!$vuetify.breakpoint.xs" sm="5" md="4">
                    <strong
                      class="subtitle-2 font-weight-bold"
                      v-html="modem.nome"
                    ></strong>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row
                  class="mt-0 ml-1"
                  :class="{ 'pl-10 pt-3 ml-n5': $vuetify.breakpoint.xs }"
                >
                  <v-col
                    class="pt-0 pl-0 pr-0 mt-n6 col-5"
                    :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                  >
                    <LabelValue
                      :label="$vuetify.lang.t('$vuetify.TECNOLOGIA')"
                      :value="modem.tecnologia ? modem.tecnologia : '--'"
                      justify="start"
                      style="width: 350px"
                      truncate
                    ></LabelValue>
                  </v-col>

                  <v-col
                    class="pt-0 pl-0 pr-0 mt-n6 col-5"
                    :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                  >
                    <LabelValue
                      :label="'Cód. empresa de campo'"
                      :value="
                        modem.codigoEmpresaCampo
                          ? modem.codigoEmpresaCampo
                          : '--'
                      "
                      justify="start"
                      style="width: 350px"
                      truncate
                    ></LabelValue>
                  </v-col>
                </v-row>

                <v-divider class="mt-0"></v-divider>

                <v-card-actions class="mb-n3">
                  <TooltipButton
                    v-if="$hasPermission('MODEMS-NOVO', [])"
                    :label="$vuetify.lang.t('$vuetify.EDITAR')"
                    :message="$vuetify.lang.t('$vuetify.EDITAR_MODEM')"
                    :event="editModem"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="modem"
                  ></TooltipButton>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row justify="center">
          <v-progress-circular
            v-if="isLoading"
            :size="30"
            :width="4"
            color="blue darken-2"
            indeterminate
            class="ml-n2 mt-3 mb-n1 text-center"
          ></v-progress-circular>
        </v-row>
        <v-row justify="center" v-if="modems.length == 0 && !isLoading">
          <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
            <WarningPanel
              v-if="!isLoading"
              :message="$vuetify.lang.t('$vuetify.NENHUM_MODEM')"
            >
            </WarningPanel>
          </v-lazy>
        </v-row>
      </div>
    </v-col>

    <ModemFormDialog
      :dialog="showDialog"
      :modem="selectedModem"
      :close="closeDialog"
      :send="sendModem"
      :isLoading="isLoading"
      :showModemAlreadyExists="showModemAlreadyExists"
    ></ModemFormDialog>
  </v-layout>
</template>

<script>
import WarningPanel from "../components/panels/WarningPanel";
import TooltipButton from "../components/TooltipButton";
import LabelValue from "../components/LabelValue";
import ModemFormDialog from "../components/dialogs/ModemFormDialog";

export default {
  components: {
    WarningPanel,
    TooltipButton,
    LabelValue,
    ModemFormDialog,
  },
  methods: {
    editModem(modem) {
      this.selectedModem = Object.assign({}, modem);
      this.showDialog = true;
    },
    hasEmptyFields(modem) {
      return !modem.nome || !modem.tecnologia || !modem.codigoEmpresaCampo;
    },
    sendModem(modem) {
      if (this.hasEmptyFields(modem)) {
        return;
      }

      this.showModemAlreadyExists = false;
      this.isLoading = true;

      if (!modem.id) {
        this.$post("/modem/save", modem).then((response) => {
          if (!response.data) {
            this.showModemAlreadyExists = true;
            this.isLoading = false;
            return;
          }

          var element = document.getElementById("main");

          this.$vuetify.goTo(element, {
            duration: 200,
            offset: 25,
            easing: "linear",
          });

          setTimeout(() => this.modems.unshift(response.data), 250);
          this.$root.$emit("invalidateFields");

          this.isLoading = false;
          this.showDialog = false;
        });

        return;
      }

      this.$post("/modem/save", modem).then((modem) => {
        var vm = this;
        this.modems.forEach(function (b, i) {
          if (b.id == modem.data.id) {
            vm.modems[i] = modem.data;
          }
        });

        this.$root.$emit("invalidateFields", true);
        this.isLoading = false;
        this.showDialog = false;
      });
    },
    createModem() {
      this.selectedModem = {};
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    searchMore() {
      this.stickFilters();

      if (this.isLoding || this.noResult) {
        return;
      }

      if (
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.scrollHeight
      ) {
        this.page++;
        this.search(this.page);
      }
    },
    search(page) {
      this.isLoading = true;
      if (!page) {
        this.page = 0;
        this.modems = [];
        this.noResult = false;
      }

      this.$get("/modem/busca", {
        searchText: this.searchText,
        page: this.page,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.modems = this.modems.concat(response.data);
        this.isLoading = false;
      });
    },
    stickFilters() {
      if (document.documentElement.scrollTop > 95) {
        document.getElementById("filtro").style =
          "position:sticky; z-index:2; top:66px; box-shadow: 0 0 10px #333; border-radius: 15px;";
      } else if (document.documentElement.scrollTop < 60) {
        document.getElementById("filtro").style = "";
      }
    },
  },
  data: () => ({
    page: 0,
    isLoading: false,
    noResult: false,
    searchText: "",
    modems: [],
    showDialog: false,
    disabled: false,
    selectedModem: undefined,
    showModemAlreadyExists: false,
  }),
  created: function () {
    this.isLoading = true;
    this.$get("/modem/busca", { searchText: "", page: 0 }).then((response) => {
      this.modems = response.data;
      this.isLoading = false;
    });
  },
};
</script>
